module.exports = __webpack_public_path__ + "img/mdi-check-green.693901d3.svg";